import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedRecord } from '../selectors/records.selectors';
import patchUncheckRecordSingleTime from '../services/patchUncheckRecordSingleTime.service';

export const uncheckRecordSingleTime = createAsyncThunk(
  'records/uncheckRecordSingleTime',
  async (timeAttributeName, { getState }) => {
    const selectedRecord = selectSelectedRecord(getState());

    const recordProjectId = selectedRecord.project;

    const checkedRecord = await patchUncheckRecordSingleTime(
      timeAttributeName,
      recordProjectId,
      selectedRecord.id
    );

    return checkedRecord;
  }
);
